import React, { useEffect, useState } from "react";
import axios from "../../api/axios";

// MUI components
import {
  Grid,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TablePagination,
  Paper,
  IconButton,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Typography,
  MenuItem,
} from "@mui/material";
import Icon from "@mui/material/Icon";

// Custom components
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function Designations() {
  const [Designations, setDesignations] = useState([]);
  const [cadres, setCadres] = useState([]);
  const [gradeLevels, setGradeLevels] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [currentItem, setCurrentItem] = useState({
    id: null,
    name: "",
    cadre_id: "",
    grade_level_id: "",
  });
  const [snackbar, setSnackbar] = useState({ open: false, message: "" });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const fetchDesignations = async () => {
    try {
      const response = await axios.get("/designations");
      setDesignations(response.data);
    } catch (err) {
      console.error("Failed to fetch designations", err);
    }
  };

  const fetchCadres = async () => {
    try {
      const response = await axios.get("/cadres");
      setCadres(response.data);
    } catch (err) {
      console.error("Failed to fetch cadres", err);
    }
  };

  const fetchGradeLevels = async () => {
    try {
      const response = await axios.get("/grade-levels");
      setGradeLevels(response.data);
    } catch (err) {
      console.error("Failed to fetch grade levels", err);
    }
  };

  useEffect(() => {
    fetchDesignations();
    fetchCadres();
    fetchGradeLevels();
  }, []);

  const handleSave = async () => {
    try {
      const payload = {
        name: currentItem.name,
        cadre_id: currentItem.cadre_id,
        grade_level_id: currentItem.grade_level_id,
      };

      if (currentItem.id) {
        await axios.put(`/designations/${currentItem.id}`, payload);
        setSnackbar({ open: true, message: "Designation updated successfully" });
      } else {
        await axios.post("/designations", payload);
        setSnackbar({ open: true, message: "Designation added successfully" });
      }

      fetchDesignations();
      setOpenDialog(false);
      setCurrentItem({ id: null, name: "", cadre_id: "", grade_level_id: "" });
    } catch (err) {
      console.error(err);
      alert("Something went wrong.");
    }
  };

  const handleEdit = (item) => {
    setCurrentItem({
      id: item.id,
      name: item.name,
      cadre_id: item.cadre_id || "",
      grade_level_id: item.grade_level_id || "",
    });
    setOpenDialog(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Designation?")) {
      try {
        await axios.delete(`/designations/${id}`);
        fetchDesignations();
        setSnackbar({ open: true, message: "Designation deleted successfully" });
      } catch (err) {
        console.error("Delete failed", err);
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedItems = Designations.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox py={3}>
        <Grid container justifyContent="space-between" alignItems="center" px={2} mb={2}>
          <Typography variant="h5">Designations</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenDialog(true)}
            sx={{ color: "#fff" }}
          >
            Add New
          </Button>
        </Grid>

        <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 3 }}>
          <Table>
            <TableHead>
              {/* <TableRow sx={{ backgroundColor: "#f0f2f5" }}>
                <TableCell sx={{ fontWeight: "bold" }}>#</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Designation Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Cadre</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Grade Level</TableCell>
                <TableCell sx={{ fontWeight: "bold", textAlign: "center" }}>Actions</TableCell>
              </TableRow> */}
            </TableHead>

            <TableBody>
              {paginatedItems.length > 0 ? (
                paginatedItems.map((item, index) => (
                  <TableRow
                    key={item.id}
                    hover
                    sx={{ "&:last-child td, &:last-child th": { borderBottom: 0 } }}
                  >
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>
                      {cadres.find((c) => c.id === item.cadre_id)?.name || (
                        <em style={{ color: "#aaa" }}>Unassigned</em>
                      )}
                    </TableCell>
                    <TableCell>
                      {gradeLevels.find((g) => g.id === item.grade_level_id)?.name || (
                        <em style={{ color: "#aaa" }}>Unassigned</em>
                      )}
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      <IconButton color="primary" onClick={() => handleEdit(item)}>
                        <Icon>edit</Icon>
                      </IconButton>
                      <IconButton color="error" onClick={() => handleDelete(item.id)}>
                        <Icon>delete</Icon>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ padding: 3 }}>
                    No Designations found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <TablePagination
            component="div"
            count={Designations.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </TableContainer>
      </MDBox>

      {/* Add/Edit Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>{currentItem.id ? "Edit Designation" : "Add New Designation"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            label="Designation Name"
            fullWidth
            margin="normal"
            value={currentItem.name}
            onChange={(e) => setCurrentItem({ ...currentItem, name: e.target.value })}
          />

          <TextField
            select
            label="Select Cadre"
            fullWidth
            margin="normal"
            value={currentItem.cadre_id}
            onChange={(e) => setCurrentItem({ ...currentItem, cadre_id: e.target.value })}
          >
            <MenuItem value="">
              <em>-- Select Cadre --</em>
            </MenuItem>
            {cadres.map((cadre) => (
              <MenuItem key={cadre.id} value={cadre.id}>
                {cadre.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="Select Grade Level"
            fullWidth
            margin="normal"
            value={currentItem.grade_level_id}
            onChange={(e) => setCurrentItem({ ...currentItem, grade_level_id: e.target.value })}
          >
            <MenuItem value="">
              <em>-- Select Grade Level --</em>
            </MenuItem>
            {gradeLevels.map((level) => (
              <MenuItem key={level.id} value={level.id}>
                {level.name}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" color="primary" sx={{ color: "#fff" }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ open: false, message: "" })}
        message={snackbar.message}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default Designations;
